import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const DIAS: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Dias,
    name: 'dias'
};
